const emailAccounTypes = {
  gmail: {
    id: 1,
  },
  office365: {
    id: 2,
  },
};

export const LIONDESK_EMAIL_ACCOUNT = 'LionDesk';

export default emailAccounTypes;
